import { DateRange, Goal, Task, Timestamp } from '@griply/types';
import { getTimeframeTimes } from '@griply/utils';
import { useMemo } from 'react';

export type UseTimeframeTimesOptions = {
  allTasks: Task[];
  today: Timestamp;
};

export const useTimeframeTimes = (
  goal: Goal | undefined,
  { allTasks, today }: UseTimeframeTimesOptions,
): DateRange =>
  useMemo(
    () => getTimeframeTimes(goal, { allTasks, today }),
    [allTasks, goal, today],
  );
